import { Pipe, PipeTransform } from '@angular/core';

// Display-only. The stored guest types (e.g. EXPECTED_VISITOR) are compared
// against by the backend and live in clients' data, so they must never change;
// this only changes the wording shown on screen. Unknown values pass through.
@Pipe({ name: 'guestTypeLabel' })
export class GuestTypeLabelPipe implements PipeTransform {
  private static readonly LABELS: { [key: string]: string } = {
    EXPECTED_VISITOR: 'Booked Visitor',
    EXPECTED_GUEST: 'Booked Guest',
  };

  transform(value: string): string {
    if (value === null || value === undefined) {
      return value;
    }
    return GuestTypeLabelPipe.LABELS[value] || value;
  }
}
